<template>
  <div class="transaction-page">
    <TransactionWrapper />
  </div>
</template>

<script>
import TransactionWrapper from '@/wrappers/TransactionWrapper.vue';

export default {
  name: 'TransactionPage',
  components: {
      TransactionWrapper,
  },
  data() {
      return {
          // Define your component's data properties here
      };
  },
  methods: {
      // Add your methods here
  },
  computed: {
      // Add your computed properties here
  },
  mounted() {
      // Lifecycle hook for when the component is mounted
  },
};
</script>

<style scoped>
.transaction-view {
    /* Add your styles here */
}
</style>